import { Lci3SalesMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import {
  SalesOptimizationChartOptions,
  salesOptimizationChart,
} from '@features/executive-report/configuration/sales-optimization-chart';
import { chartOptionsToBase64Svg } from '@features/powerpoint';
import { SECTION_X_OFFSET } from './layout';
import { SalesOptimizationSummaryOptions } from '../sales-optimization-summary';

const PPT_CHART_WIDTH = 5.84;
const PPT_CHART_HEIGHT = 3.55;
const PTT_CHART_SCALING_FACTOR = 100;
const PX_CHART_WIDTH = PPT_CHART_WIDTH * PTT_CHART_SCALING_FACTOR;
const PX_CHART_HEIGHT = PPT_CHART_HEIGHT * PTT_CHART_SCALING_FACTOR;

const salesMetricsToChartData = (
  salesMetrics: Lci3SalesMetrics
): SalesOptimizationChartOptions['data'] => [
  {
    sales: salesMetrics.penetrationSales.total ?? 0,
    lift: salesMetrics.penetrationLift.total ?? 0,
    label: 'Penetration',
  },
  {
    sales: salesMetrics.transactionRateSales.total ?? 0,
    lift: salesMetrics.transactionRateLift.total ?? 0,
    label: 'Transaction Rate',
  },
  {
    sales: salesMetrics.transactionSizeSales.total ?? 0,
    lift: salesMetrics.transactionSizeLift.total ?? 0,
    label: 'Transaction Size',
  },
];

export const images = (options: SalesOptimizationSummaryOptions) => {
  return [
    ...(options.midCampaignSalesMetrics
      ? [
          {
            data: chartOptionsToBase64Svg({
              chartOptions: salesOptimizationChart({
                data: salesMetricsToChartData(options.midCampaignSalesMetrics),
              }),
              width: PX_CHART_WIDTH,
              height: PX_CHART_HEIGHT,
            }),
            h: PPT_CHART_HEIGHT,
            w: PPT_CHART_WIDTH,
            x: 0.82,
            y: 3.38,
          },
        ]
      : []),
    {
      data: chartOptionsToBase64Svg({
        chartOptions: salesOptimizationChart({
          data: salesMetricsToChartData(options.currentSalesMetrics),
        }),
        width: PX_CHART_WIDTH,
        height: PX_CHART_HEIGHT,
      }),
      h: PPT_CHART_HEIGHT,
      w: PPT_CHART_WIDTH,
      x: 0.82 + SECTION_X_OFFSET,
      y: 3.38,
    },
  ];
};
